/** What an Un-do is started from - the API's UndoKinds, which never change. */
export const UndoKinds = {
  invoicePiece: 'InvoicePiece',
  invoice: 'Invoice',
  invoiceDespatchNote: 'InvoiceDespatchNote',
  despatchNote: 'DespatchNote',
  cut: 'Cut',
  receipt: 'Receipt',
} as const;

/** How far back an Un-do goes - the API's UndoStoppingPoints. */
export const UndoStoppingPoints = {
  offInvoice: 'OffInvoice',
  offNote: 'OffNote',
  backToAllocated: 'BackToAllocated',
  backToFreeStock: 'BackToFreeStock',
  mergeBack: 'MergeBack',
  reverseDelivery: 'ReverseDelivery',
} as const;
